export default __webpack_public_path__ + "static/media/persik.ae9f0072.png";